import CockpitNotificationStateLookupResourceModel from '../../generated/types/model/resource/CockpitNotificationStateLookupResourceModel';

export default class CockpitNotificationStateLookupResourceViewModel extends CockpitNotificationStateLookupResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
